module.exports = __webpack_public_path__ + "static/media/farooq.9331f9bd.png";